/**
 * Enum defining all supported custom markdown tag types
 * Always use lowercase tag names for HTML standards compliance
 */
export var MarkdownTagType;
(function (MarkdownTagType) {
    MarkdownTagType["TABLE"] = "tableitem";
    MarkdownTagType["FIELD"] = "fielditem";
    MarkdownTagType["ACCORDION"] = "accordionitem";
    MarkdownTagType["CODE"] = "codeitem";
    MarkdownTagType["CAMPAIGN"] = "campaignitem";
    MarkdownTagType["MENTION_ENTITY"] = "mentionentityitem";
})(MarkdownTagType || (MarkdownTagType = {}));
/**
 * Utility to create any markdown tag with proper lowercase tag names
 * Creates enclosed tags: <tagname attributes>content</tagname>
 */
const createTag = (tagName, attributes, content) => {
    const attrs = Object.entries(attributes)
        .filter(([_, value]) => value !== undefined && value !== null)
        .map(([key, value]) => `${key}="${value}"`)
        .join(' ');
    // Convert tag name to lowercase for HTML standards compliance
    const lowerTagName = tagName.toLowerCase();
    return `<${lowerTagName}${attrs ? ` ${attrs}` : ''}>${content}</${lowerTagName}>`;
};
/**
 * Utility functions for each tag type
 */
export const createTableTag = (attributes, content) => createTag(MarkdownTagType.TABLE, attributes, content);
export const createFieldTag = (attributes, content) => createTag(MarkdownTagType.FIELD, attributes, content);
export const createAccordionTag = (attributes, content) => createTag(MarkdownTagType.ACCORDION, attributes, content);
export const createCodeTag = (attributes, content) => createTag(MarkdownTagType.CODE, attributes, content);
export const createCampaignTag = (attributes, content) => createTag(MarkdownTagType.CAMPAIGN, attributes, content);
export const createMentionEntityTag = (attributes, content) => createTag(MarkdownTagType.MENTION_ENTITY, attributes, content);
//# sourceMappingURL=markdown.js.map